import { FunctionComponent } from "react";

import { CLOUD_INTEGRATIONS } from "shared/CloudIntegration/types";
import useDetachCloudIntegration from "shared/CloudIntegration/useDetachCloudIntegration";
import {
  StackAwsIntegrationAttachment,
  StackAzureIntegrationAttachment,
  StackIntegrationGcp,
} from "types/generated";

import AttachCloudDetailsCard from "./Card";

export type AttachCloudDetailsCloudConfig = Array<{
  name: string;
  logo: FunctionComponent;
  type: CLOUD_INTEGRATIONS;
}>;

type AttachCloudDetailsProps = {
  attachedIntegration:
    | StackAwsIntegrationAttachment
    | StackAzureIntegrationAttachment
    | StackIntegrationGcp;
  attachedIntegrationType: CLOUD_INTEGRATIONS;
  cloudConfig: AttachCloudDetailsCloudConfig;
  className?: string;
  entityId?: string;
  refetchQueries?: string[];
  readOnly?: boolean;
  onSuccessDetach?: () => void;
  stackLabels?: string[];
};

const AttachCloudDetails = ({
  attachedIntegration,
  attachedIntegrationType,
  cloudConfig,
  className,
  entityId,
  refetchQueries,
  readOnly,
  onSuccessDetach,
  stackLabels,
}: AttachCloudDetailsProps) => {
  const { detach, detachLoading } = useDetachCloudIntegration({
    refetchQueries,
  });

  const handleDetach = () => {
    switch (attachedIntegrationType) {
      case CLOUD_INTEGRATIONS.AWS:
      case CLOUD_INTEGRATIONS.Azure:
        if ("id" in attachedIntegration) {
          detach(
            { type: attachedIntegrationType, attachmentId: attachedIntegration.id },
            onSuccessDetach
          );
        }
        break;
      case CLOUD_INTEGRATIONS.GCP:
        if (entityId) {
          detach({ type: attachedIntegrationType, entityId }, onSuccessDetach);
        }
    }
  };

  return (
    <AttachCloudDetailsCard
      attachedIntegration={attachedIntegration}
      attachedIntegrationType={attachedIntegrationType}
      cloudConfig={cloudConfig}
      className={className}
      readOnly={readOnly}
      onDetach={handleDetach}
      detachLoading={detachLoading}
      stackLabels={stackLabels}
    />
  );
};

export default AttachCloudDetails;
